module.exports = __webpack_public_path__ + "img/hotdog.bf201f6b.jpg";